import { render } from "./PerformMonitor.vue?vue&type=template&id=b1623fa8"
import script from "./PerformMonitor.vue?vue&type=script&lang=js"
export * from "./PerformMonitor.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__